import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import Loadfirst from './Loadfirst';
// import reportWebVitals from './reportWebVitals';
import { AuthProvider } from "./AuthContext";
import { Login } from '@mui/icons-material';
import Loadfirsts from './Loadfirst';
import swDev  from './swDev';
import 'bootstrap/dist/css/bootstrap.min.css';

ReactDOM.render(
  <React.StrictMode>
    <AuthProvider>
      <Loadfirst />      
    </AuthProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
// swDev();

// import React from 'react';
// import ReactDOM from 'react-dom';
// import App from './App';
// import './index.css';
// import 'bootstrap/dist/css/bootstrap.min.css';

// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById('root')
// );

